import './widget.scss';
import assist from '../../assets/img/icons/assist.svg';

function Housing() {
  return (
    <div className="widget widget--grey">
      <img src={assist} className="widget__icon" alt="Assistance" />
      <p className="widget__stat">$6 Million</p>
      <p className="widget__text widget__text--larger">
        amount of assistance The Salvation Army has provided to North Texas individuals since the
        start of the pandemic
      </p>
    </div>
  );
}

export default Housing;
